var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-list-group',[_c('b-list-group-item',{attrs:{"to":"/website/sports-offered"}},[_vm._v("Sports Offerred")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }